__webpack_require__.p = "https://staging-assets.rosi.silkroad.com/";